"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeActionCreator = makeActionCreator;
exports.makeAsyncActionCreator = makeAsyncActionCreator;
exports.REQUEST = exports.FAILURE = exports.SUCCESS = exports.API_REQUEST = exports.API_FAILURE = exports.API_SUCCESS = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

// For only thunk MIDDLEWARE
var API_SUCCESS = 'SUCCESS';
exports.API_SUCCESS = API_SUCCESS;
var API_FAILURE = 'FAILURE';
exports.API_FAILURE = API_FAILURE;
var API_REQUEST = 'REQUEST'; // For working with API MIDDLEWARE

exports.API_REQUEST = API_REQUEST;
var SUCCESS = 'SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'FAILURE';
exports.FAILURE = FAILURE;
var REQUEST = 'REQUEST';
exports.REQUEST = REQUEST;

var _trim = function _trim(payload) {
  if (!payload) {
    return ['payload'];
  }

  return payload.split(',').map(function (item) {
    return item.trim();
  });
};
/**
 * Create a simple action creator according to the type and payload structure
 * @param type  {String}  The type to dispatch
 * @param argNames  {String}  Spread of strings to pass (each argument must be string)
 * @returns {function(...[*]): {type: *}} The action creator function to be called : if argsName passed,
 * will create the structure according to the desired argNames. Other will only accept and object and set it as payload
 */


function makeActionCreator(type) {
  for (var _len = arguments.length, argNames = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    argNames[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var action = {
      type: type
    };

    if (!(0, _isEmpty["default"])(argNames)) {
      argNames.forEach(function (arg, index) {
        if (!(0, _isEmpty["default"])(arg)) {
          action[argNames[index]] = args[index];
        }
      });
    } else {
      var payload = args[0];
      action.payload = payload;
    }

    return action;
  };
}
/**
 * Create the normalized action creators for a specific flow
 * @param type {String} The type to dispatch to -
 * success, failure, request will be added automatically
 * @param successPayload {String} the structure of the success payload -
 * separated by comma if multiple - defaults to payload
 * @param errorPayload {String} the structure of the error payload -
 * separated by comma if multiple - defaults to payload
 * @param requestPayload {String} the structure of the request payload -
 * separated by comma if multiple - defaults to payload
 * @returns {{success: {function(...[*])}, failure: {function(...[*])}, request: {function(...[*])}}
 */


function makeAsyncActionCreator(type) {
  var successPayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var errorPayload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var requestPayload = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  var sPayload = _trim(successPayload);

  var ePayload = _trim(errorPayload);

  var rPayload = _trim(requestPayload);

  return {
    success: makeActionCreator.apply(void 0, ["".concat(type, " ").concat(API_SUCCESS)].concat((0, _toConsumableArray2["default"])(sPayload))),
    failure: makeActionCreator.apply(void 0, ["".concat(type, " ").concat(API_FAILURE)].concat((0, _toConsumableArray2["default"])(ePayload))),
    request: makeActionCreator.apply(void 0, ["".concat(type, " ").concat(API_REQUEST)].concat((0, _toConsumableArray2["default"])(rPayload)))
  };
}